<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 messaging">
        <div style="display: flex; flex-direction: column; height: 100vh">
          <div id="scroll" class="msg_history" style="flex: 1">
            <template v-for="item in atendimento.messages">
              <div
                class="incoming_msg"
                v-if="item.type == 'you'"
                :key="item.id"
              >
                <div class="incoming_msg_img">
                  <img
                    src="https://img.icons8.com/office/30/000000/collaborator-male--v2.png"
                  />
                </div>
                <div class="received_msg">
                  <div class="received_withd_msg">
                    <span class="time_date" style="margin-top: -2px">{{
                      item.agente
                    }}</span>
                    <pre>{{ item.text }}</pre>
                    <!-- <span v-show="item.file" @click="download(item)">
                    <b-icon-document-text></b-icon-document-text>
                    {{item.file_name}}
                    </span>-->
                    <span class="time_date">
                      {{ item.date | moment("HH:mm") }}
                      {{ item.date | moment("L") }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="incoming_msg" v-if="item.type == ''" :key="item.id">
                <div class="incoming_msg_img">
                  <img src="https://img.icons8.com/dusk/30/000000/bot.png" />
                </div>
                <div class="received_msg">
                  <div class="received_withd_msg">
                    <pre>{{ item.text }}</pre>
                    <span class="time_date">
                      {{ item.date | moment("HH:mm") }}
                      {{ item.date | moment("L") }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="outgoing_msg" v-if="item.type == 'me'" :key="item.id">
                <div class="sent_msg">
                  <p :style="getColor()">{{ item.text }}</p>
                  <span class="time_date">
                    {{ item.date | moment("HH:mm") }}
                    {{ item.date | moment("L") }}
                  </span>
                </div>
              </div>
            </template>
          </div>
          <div class="type_msg">
            <div class="container-fluid">
              <div style="display: flex; flex-direction: row" class="mt-2">
                <div style="flex: 0.2">
                  <b-dropdown
                    size="lg"
                    variant="link"
                    toggle-class="text-decoration-none"
                    no-caret
                  >
                    <template v-slot:button-content>
                      <img
                        src="https://img.icons8.com/cotton/30/000000/settings--v1.png"
                        style="margin-bottom: 5px"
                      />
                    </template>
                    <b-dropdown-item @click="exit()">
                      <img
                        src="https://img.icons8.com/windows/25/000000/exit.png"
                      />
                      <span>Encerrar atendimento</span>
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
                <b-form-input
                  id="input-2"
                  v-model="text"
                  placeholder="Mensagem..."
                  style="flex: 4"
                  v-on:keyup.enter="send()"
                ></b-form-input>
                <button
                  @click="send()"
                  class="msg_send_btn"
                  type="button"
                  style="flex: 0.2"
                >
                  <img
                    style="cursor: pointer"
                    src="https://img.icons8.com/ios/25/000000/paper-plane.png"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import config from "../../config.json";
import VueSocketIO from "vue-socket.io";
import Vue from "vue";
import store from "../store";

const { mapState, mapActions } = createNamespacedHelpers("Atendimento");

export default {
  data() {
    return {
      text: "",
    };
  },
  created() {
    Vue.use(
      new VueSocketIO({
        debug: false,
        connection: config.enderecoCsa,
        vuex: {
          store,
          actionPrefix: "ws_",
          mutationPrefix: "ws_",
        },
      })
    );
    this.authenticate({ ...this.user });
    setTimeout(() => {
      this.sendMessage(
        `${this.user.nome} - ${this.user.email} - ${this.user.numero}`
      );
    }, 500);
    //this.getState();
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      atendimento: (state) => state.atendimento,
    }),
    messages: {
      get() {
        console.log("passou aqui");
        return this.atendimento.messages;
      },
    },
  },

  watch: {
    messages() {
      setTimeout(() => {
        var container = this.$el.querySelector("#scroll");
        container.scrollTop = container.scrollHeight;
      }, 500);

      this.setState();
      if (this.atendimento.lastEvent === "EncerrarAtendimento") {
        localStorage.clear();
        this.removeState();
        this.$router.push("/");
      }
    },
  },
  methods: {
    ...mapActions([
      "authenticate",
      "sendMessage",
      "setState",
      "getState",
      "removeState",
    ]),
    getColor() {
      return `background:${config.corPrimaria} !important`;
    },
    send() {
      this.sendMessage(this.text);
      this.text = "";
    },
    exit() {
      localStorage.clear();
      this.removeState();

      this.$router.push("/");
    },
    download(data) {
      // let aux = data.file.file_name.split(".");
      // let ext = aux[1];

      var FileSaver = require("file-saver");
      var file = new File([data.file.file], data.file.file_name, {
        type: "image/png",
      });
      console.log(file);
      FileSaver.saveAs(file, data.file.file_name);
      // fetch(`data:application/${ext};base64`, +data.file.file)
      //   .then(function(resp) {
      //     return resp.blob();
      //   })
      //   .then(function(blob) {
      //     saveAS(blob);
      //   });
    },
  },
};
</script>